import { Injectable, Injector } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { IUaePassAuthenticationResult } from '../shared/model/uae-pass-auth-result.model';
import { HttpClient } from '@angular/common/http';
import { JwtService } from './jwt.service';
import { ConfigService } from '../../core/config/config.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class UaePassAuthService {
  private userSubject = new BehaviorSubject<any>(null);
  private uaePassToken: any;
  user$ = this.userSubject.asObservable();

  constructor(
    private router: Router,
    private injector: Injector,
    private config: ConfigService,
    private jwtService: JwtService
  ) {}

  isAuthLoginRoute(): boolean {
    return this.router.url.startsWith('/auth/login');
  }

  getRedirectUrl(redirect?: string): Observable<{ url: string }> {
    return this.injector.get(HttpClient).get<{
      url: string;
    }>(this.config.apiUrl + `/Identity/api/UaePass/get-auth-code-url?fe_redirect_url=${redirect}&logout=true`);
  }

  getUaePassToken(): string {
    return this.uaePassToken;
  }

  setUaePassToken(token: string | undefined) {
    if (token) {
      this.uaePassToken = token;
    }
  }

  authenticateByUaePass(
    code: string,
    redirect?: string
  ): Observable<IUaePassAuthenticationResult> {
    return this.injector
      .get(HttpClient)
      .get<IUaePassAuthenticationResult>(
        this.config.apiUrl +
          `/Identity/api/UaePass/Authenticate/${code}?fe_redirect_url=${redirect}`
      )
      .pipe(
        tap((res: IUaePassAuthenticationResult) => {
          this.jwtService.setToken(res?.apecoToken);
          this.setUaePassToken(res?.uaePassAccessToken);
          this.userSubject.next(this.jwtService.getUser());
        })
      );
  }

  registerUaePassAccount(
    uaePassToken: string
  ): Observable<IUaePassAuthenticationResult> {
    return this.injector
      .get(HttpClient)
      .post<IUaePassAuthenticationResult>(
        this.config.apiUrl + '/Identity/api/UaePass/Register',
        { uaePassAccessToken: uaePassToken }
      )
      .pipe(
        tap((res: IUaePassAuthenticationResult) => {
          this.jwtService.setToken(res.apecoToken);
          this.userSubject.next(this.jwtService.getUser());
        })
      );
  }

  linkUaePassAccount(
    username: string,
    password: string,
    uaePassToken: string
  ): Observable<IUaePassAuthenticationResult> {
    return this.injector
      .get(HttpClient)
      .post<IUaePassAuthenticationResult>(
        this.config.apiUrl + '/Identity/api/UaePass/Link',
        {
          username,
          password,
          uaePassAccessToken: uaePassToken
        }
      )
      .pipe(
        tap((res: IUaePassAuthenticationResult) => {
          this.jwtService.setToken(res.apecoToken);
          this.userSubject.next(this.jwtService.getUser());
        })
      );
  }

  logoutFromUaePass(): Observable<any> {
    return this.injector
      .get(HttpClient)
      .get(this.config.apiUrl + '/Identity/api/UaePass/get-logout-url')
      .pipe(
        tap((res: any) => {
          window.location.href = res?.url;
        })
      );
  }
}
